const mediaItems = [
  {
    title: '《星河纪元：重启》终极预告',
    desc: '浩瀚宇宙中的人类命运之战，年度最受期待的科幻巨制',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20space%20battle%20scene%20with%20massive%20starships%20and%20explosions%2C%20epic%20scale%2C%20dramatic%20lighting%20with%20orange%20and%20blue%20contrast%2C%20film%20grain%2C%20movie%20trailer%20thumbnail%20style%2C%20dark%20space%20background%20with%20nebula&width=800&height=450&seq=media-01&orientation=landscape',
    duration: '2:35',
    tag: '预告片',
  },
  {
    title: '《暗夜追踪者》导演访谈',
    desc: '独家对话导演，揭秘悬疑神作背后的创作故事与拍摄秘辛',
    img: 'https://readdy.ai/api/search-image?query=Professional%20film%20director%20interview%20setup%20with%20cinematic%20lighting%2C%20warm%20studio%20atmosphere%2C%20movie%20posters%20on%20background%20wall%2C%20film%20production%20aesthetic%2C%20deep%20shadows%20and%20amber%20key%20light%2C%20documentary%20style&width=800&height=450&seq=media-02&orientation=landscape',
    duration: '8:12',
    tag: '幕后',
  },
  {
    title: '经典电影修复对比特辑',
    desc: '4K修复技术让老电影焕发新生，画质前后对比令人惊叹',
    img: 'https://readdy.ai/api/search-image?query=Split%20screen%20comparison%20showing%20film%20restoration%20before%20and%20after%2C%20vintage%20movie%20scene%20transformed%20with%20modern%20digital%20restoration%2C%20cinematic%20color%20grading%2C%20warm%20nostalgic%20tones%2C%20technical%20aesthetic&width=800&height=450&seq=media-03&orientation=landscape',
    duration: '5:48',
    tag: '特辑',
  },
  {
    title: '暑期档观影指南全解读',
    desc: '一口气看完暑期必看片单，从动作到文艺一网打尽',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20movie%20poster%20collage%20with%20warm%20summer%20vibes%2C%20film%20strip%20border%20design%2C%20golden%20sunset%20lighting%2C%20cinematic%20composition%2C%20energetic%20and%20exciting%20atmosphere%2C%20movie%20marathon%20aesthetic&width=800&height=450&seq=media-04&orientation=landscape',
    duration: '12:20',
    tag: '指南',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 text-center mb-3">精彩预告</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          最新预告片、幕后花絮与观影指南，精彩内容一网打尽
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-500/30 transition-all cursor-pointer group"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-16 h-16 flex items-center justify-center rounded-full bg-primary-500/90 group-hover:bg-primary-500 transition-all group-hover:scale-110">
                    <i className="ri-play-fill text-2xl text-background-50 ml-1"></i>
                  </span>
                </div>
                <span className="absolute bottom-3 right-3 px-2 py-0.5 rounded-md bg-background-950/80 text-foreground-50 text-xs whitespace-nowrap">{item.duration}</span>
                <span className="absolute top-3 left-3 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-medium whitespace-nowrap">{item.tag}</span>
              </div>
              <div className="p-4">
                <h3 className="text-base font-semibold text-foreground-200 group-hover:text-primary-400 transition-colors mb-1">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}